<div [formGroup]="form">
  <mat-select
    [formControlName]="controlName"
    [placeholder]="'CHOOSE' | translate"
  >
    <mat-option value="">{{'ALL' | translate}}</mat-option>
    <mat-option
      *ngFor="let region of regions"
      [value]="region"
    >
      {{region}}
    </mat-option>
  </mat-select>
</div>
